import http from '@/common/http.js'

function info(callback, check) {
	let url = 'user/get';
	
	if(check) url += '?check=1';
	
	http.request({
		url		: url,
		success: (res) => {
			// res.data.level = 1;
			
			window.sessionStorage.setItem('uid',			res.data.uid);
			window.sessionStorage.setItem('nickname',		res.data.nickname);
			window.sessionStorage.setItem('level', 			res.data.level);
			window.sessionStorage.setItem('avatar',			res.data.avatar);
			window.sessionStorage.setItem('storage_used',	res.storage.used);
			window.sessionStorage.setItem('storage_total',	res.storage.total);
			callback && callback(res);
		}
	})
}

//验证码
function code(params,callback){
	http.request({
		url		: 'user/code',
		data	: params,
		force	: true,
		success: (res)=> {
			callback && callback(res);
		}
	})
}

//登录
function login(params,callback){
	http.request({
		url		: 'user/login',
		data	: params,
		force	: true,
		success: (res)=> {
			window.localStorage.setItem('token',res.token);
			callback && callback(res);
		}
	})
}

//修改密码
function modifyPassword(params, callback){
	http.request({
		url		: 'user/set_password',
		data	: params,
		success: (res)=> {
			callback && callback(res);
		}
	})
}

//修改昵称
function modifyInfo(params, callback){
	http.request({
		url		: 'user/set_info',
		data	: params,
		success: (res)=> {
			callback && callback(res);
		}
	})
}

//签到
function signIn(callback){
	window.localStorage.setItem('signTime', new Date().getTime());
	
	http.request({
		url		: 'user/sign',
		success	: (res)=>{
			callback && callback(res);
		},
		error : res=>{
			callback && callback(res);
		}
	})
}

function score(callback){
	http.request({
		url		: 'user/score',
		success: (res)=> {
			callback && callback(res);
		}
	})
}

function scoreLog(params, callback) {
	http.request({
		url		: 'user/score_log',
		data	: params,
		dialog	: true,
		success: (res) => {
			callback && callback(res);
		}
	})
}

export default {
	info,
	code,
	login,
	score,
	modifyPassword,
	modifyInfo,
	signIn,
	scoreLog,
}